// Lanes carry no road class of their own. It sits on the road area they belong to,
// two relations away:
//
//   lane --(role lane)-- lane_of_area relation --(role area)--> lane_group | junction_area
//                                                               └ meta_temp_surface_road_class
//
// Pure on purpose (no ol/*) so the node tests can reach it; works on anything with
// OL Feature's get / getKeys / getId.

const ROAD_CLASS_SUFFIX = "-meta_temp_surface_road_class";

/**
 * @param {Array<{get: Function, getKeys: Function, getId: Function}>} features
 * @returns {Map<string, string>} lane id -> road class, for every lane that resolves
 */
export function laneRoadClasses(features) {
  const featureById = new Map(features.map((f) => [f.getId(), f]));
  const classById = new Map();
  features.forEach((relation) => {
    if (
      relation.get("type") !== "ORBIS_RELATION" ||
      relationType(relation) !== "lane_of_area"
    ) {
      return;
    }
    const members = relationMembers(relation);
    const area = members.find((m) => m.role === "area");
    const roadClass = area && roadClassOf(featureById.get(area.id));
    if (!roadClass) {
      return;
    }
    members
      .filter((m) => m.role === "lane")
      .forEach((m) => classById.set(m.id, roadClass));
  });
  return classById;
}

function relationType(relation) {
  const key = relation
    .getKeys()
    .find((k) => k.endsWith("-type") && !k.startsWith("revision-"));
  return key && relation.get(key);
}

function roadClassOf(area) {
  if (!area) {
    return undefined;
  }
  const key = area
    .getKeys()
    .find((k) => k.endsWith(ROAD_CLASS_SUFFIX) && !k.startsWith("revision-"));
  return key && area.get(key);
}

function relationMembers(relation) {
  return relation
    .getKeys()
    .filter((k) => k.startsWith("relation-member-") && k.endsWith("-id"))
    .map((k) => ({
      id: relation.get(k),
      role: relation.get(k.replace(/-id$/, "-role")),
    }));
}
